import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import SignatureScreen from '../../../../../components/SignatureScreen.vue'
import moment from 'moment'

export default {
  props: {
    serviceOrder: Object,
    hasCalled: Boolean,
  },

  components: {
    SignatureScreen,
  },

  created() {
    this.currentUser = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    if (this.serviceOrder) {
      this.currentServiceOrder = this.serviceOrder
      this.closeServiceOrderDateTime =
        this.serviceOrder.closeServiceOrderDateTime
      this.disable =
        this.institution.userType == 4 ||
        this.institution.userType == 5 ||
        this.serviceOrder.status == 1
      // Verificar se há serviços com etapas externas
      if (this.serviceOrder.services) {
        const statusStep = this.serviceOrder.services.map(
          (service) => service.statusStepServiceOrder
        )
        this.hasExternalServices =
          statusStep.includes(0) ||
          statusStep.includes(1) ||
          statusStep.includes(5)
      }
    }
  },

  data: () => ({
    newSchedule: false,
    step: 0,
    selectedTab: 0,
    errorMessage: '',
    menuCloseDate: false,
    loading: false,
    firstValid: false,
    error: false,
    signatureErrorDialog: false,
    closeServiceOrderDateTimeError: false,
    disable: false,
    closeDate: null,
    closeTime: null,
    closeServiceOrderDateTime: null,
    currentUser: {},
    option: 0,
    nextOrders: [],
    hasExternalServices: false,
    currentServiceOrder: {
      id: 0,
      ratingServiceCompleted: null,
      ratingServiceTime: null,
      closeDate: null,
      emailForEvaluation: null,
    },
    newRequestDate: null,
    signature: '',
    useResponsibleSignature: false,
    closeDateRules: [(v) => !!v || 'Data e hora requerida'],
    emailRules: [(v) => v == null || /.+@.+\..+/.test(v) || 'E-mail inválido'],

    apiService: new ApiService(),
  }),

  computed: {
    title() {
      if (this.step === 2 || (this.step == 3 && this.newSchedule)) {
        return 'Novo agendamento'
      }

      return this.currentServiceOrder.status == 0
        ? this.$t('Fechamento de Ordem de Serviço')
        : this.$t('Ordem de Serviço Fechada')
    },

    descriptionText() {
      if (
        this.serviceOrder.equipment &&
        this.serviceOrder.equipment.standardEquipment
      ) {
        if (
          (this.serviceOrder.serviceOrderType === 6 ||
            this.serviceOrder.serviceOrderType === 'Calibração') &&
          this.serviceOrder.equipment.standardEquipment.calibrationSet
        ) {
          return 'Deseja agendar sua próxima calibração para este equipamento?'
        } else if (
          (this.serviceOrder.serviceOrderType === 2 ||
            this.serviceOrder.serviceOrderType === 'Segurança elétrica') &&
          this.serviceOrder.equipment.standardEquipment.electricalEngineeringSet
        ) {
          return 'Deseja agendar seu próximo Teste de Segurança elétrica para este equipamento?'
        } else if (
          (this.serviceOrder.serviceOrderType === 7 ||
            this.serviceOrder.serviceOrderType === 'Validação/Qualificação') &&
          this.serviceOrder.equipment.standardEquipment
            .validationQualificationSet
        ) {
          return 'Deseja agendar sua próxima Validação/Qualificação para este equipamento?'
        } else if (
          this.serviceOrder.serviceOrderType === 4 ||
          this.serviceOrder.serviceOrderType === 'Rotina de Inspeção'
        ) {
          return 'Deseja agendar sua próxima Rotina de Inspeção para este equipamento?'
        }
      } else {
        if (
          this.serviceOrder.serviceOrderType === 4 ||
          this.serviceOrder.serviceOrderType === 'Rotina de Inspeção'
        ) {
          return 'Deseja agendar sua próxima Rotina de Inspeção para este setor?'
        }
      }

      return ''
    },

    tableTitle() {
      if (
        this.serviceOrder.equipment &&
        this.serviceOrder.equipment.standardEquipment
      ) {
        if (
          (this.serviceOrder.serviceOrderType === 6 ||
            this.serviceOrder.serviceOrderType === 'Calibração') &&
          this.serviceOrder.equipment.standardEquipment.calibrationSet
        ) {
          return 'Próximas calibrações para este equipamento:'
        } else if (
          (this.serviceOrder.serviceOrderType === 2 ||
            this.serviceOrder.serviceOrderType === 'Segurança elétrica') &&
          this.serviceOrder.equipment.standardEquipment.electricalEngineeringSet
        ) {
          return 'Próximos Testes de Segurança elétrica para este equipamento:'
        } else if (
          (this.serviceOrder.serviceOrderType === 7 ||
            this.serviceOrder.serviceOrderType === 'Validação/Qualificação') &&
          this.serviceOrder.equipment.standardEquipment
            .validationQualificationSet
        ) {
          return 'Próximas Validação/Qualificação para este equipamento:'
        }
      }

      return ''
    },

    finalTitle() {
      if (this.newSchedule) {
        return 'Agendamento realizado com sucesso!'
      }
      return 'Ordem de serviço fechada! Missão cumprida 🎯'
    },

    dateLabel() {
      if (
        this.serviceOrder.equipment &&
        this.serviceOrder.equipment.standardEquipment
      ) {
        if (
          (this.serviceOrder.serviceOrderType === 6 ||
            this.serviceOrder.serviceOrderType === 'Calibração') &&
          this.serviceOrder.equipment.standardEquipment.calibrationSet
        ) {
          return 'Próxima calibração:'
        } else if (
          (this.serviceOrder.serviceOrderType === 2 ||
            this.serviceOrder.serviceOrderType === 'Segurança elétrica') &&
          this.serviceOrder.equipment.standardEquipment.electricalEngineeringSet
        ) {
          return 'Próximo Teste de Segurança Elétrica:'
        } else if (
          (this.serviceOrder.serviceOrderType === 7 ||
            this.serviceOrder.serviceOrderType === 'Validação/Qualificação') &&
          this.serviceOrder.equipment.standardEquipment
            .validationQualificationSet
        ) {
          return 'Próxima Validação/Qualificação:'
        }
      }

      return ''
    },

    buttonText() {
      switch (this.step) {
        case 0:
        case 1:
          return 'Confirmar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    validateDates() {
      const attendDate = this.serviceOrder.dateTimeAttend
      const finalDate = this.closeServiceOrderDateTime
      let valid = true

      if (
        !!attendDate &&
        !!finalDate &&
        moment(attendDate).isAfter(moment(finalDate))
      ) {
        this.$toast.warning(
          'A data de fechamento não pode ser antes da data de atendimento'
        )
        valid = false
      }

      if (valid && this.serviceOrder.services && this.serviceOrder.services.length > 0) {
        const stepEndDates = this.serviceOrder.services
          .filter((s) => !!s.dateTimeEndStep)
          .map((s) => moment(s.dateTimeEndStep))

        if (stepEndDates.length > 0) {
          const latestStepEnd = moment.max(stepEndDates)
          if (!!finalDate && latestStepEnd.isAfter(moment(finalDate))) {
            this.$toast.warning(
              'A Data e hora fechamento não pode ser anterior à Data e hora fim dos serviços lançados nesta ordem de serviço.'
            )
            valid = false
          }
        }
      }

      return valid
    },

    close() {
      if (this.step > 1) {
        this.$router.push('/serviceOrders')
      }
      this.$emit('close')
    },

    back() {
      this.step = Math.max(0, this.step - 1)
    },

    async next() {
      if (this.step === 0) {
        this.closeServiceOrderDateTimeError = !this.closeServiceOrderDateTime
        if (this.closeServiceOrderDateTimeError) return

        if (!this.$refs.firstForm.validate() || !this.validateDates()) return

        if (this.currentServiceOrder.supplierId != null) {
          if (
            (this.currentServiceOrder.ratingServiceCompleted == null ||
              this.currentServiceOrder.ratingServiceTime == null) &&
            (this.currentServiceOrder.isExternal || this.hasExternalServices)
          ) {
            this.$toast.error('Avaliação obrigatória')
            return
          }
        }

        this.step = 1
      } else if (this.step === 1) {
        await this.signServiceOrder()
      } else if (this.step === 2) {
        this.scheduleOrder()
      } else {
        this.close()
      }
    },

    scheduleOrder() {
      if (!this.newSchedule) {
        this.step++
        return
      }

      if (this.newRequestDate) {
        this.apiService
          .post('serviceOrder/schedule-new-order', {
            serviceOrderId: this.serviceOrder.id,
            requestDate: moment(this.newRequestDate).format(
              'yyyy-MM-DDTHH:mm:ss'
            ),
          })
          .then(() => {
            this.$toast.success('Agendamento realizado com sucesso!')
            this.step++
          })
      } else {
        this.$toast.error('Insira uma data para o agendamento do novo serviço!')
      }
    },

    formatDateTime(date) {
      return Utils.dateTime(date)
    },

    parseDate(date) {
      if (!date) return null

      const dateTimeSplit = date.split(' ')

      const [day, month, year] = dateTimeSplit[0].split('/')
      const time = dateTimeSplit[1]

      if (time) {
        return `${year}-${month.padStart(2, '0')}-${day.padStart(
          2,
          '0'
        )} ${time}:00`
      }

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('T')[0].split('-')
      return `${day}/${month}/${year}`
    },

    async signServiceOrder(data) {
      if (this.option == 0) {
        if (this.currentUser.signatureImage) {
          this.currentServiceOrder.isExecutingSigned = true
          this.currentServiceOrder.executingUserId = this.currentUser.id
          this.submit()
        } else {
          this.signatureErrorDialog = true
        }
      } else if (this.option == 1) {
        this.currentServiceOrder.isExecutingSigned = true
        this.currentServiceOrder.executingUserId = this.currentUser.id
        this.signature = data
        this.submit()
      } else {
        if (!this.currentServiceOrder?.responsibleName) {
          this.$toast.error('Nenhum responsável encontrado na Ordem de Serviço!')
          return
        }
        this.useResponsibleSignature = true
        this.submit()
      }
    },

    setNowDate() {
      this.closeServiceOrderDateTime = !this.closeServiceOrderDateTime
        ? new Date()
        : this.closeServiceOrderDateTime
    },

    setNowRequestDate() {
      this.newRequestDate = !this.newRequestDate
        ? new Date()
        : this.newRequestDate
    },

    async getNextOrders() {
      this.apiService
        .get('serviceOrder/new-equipment-orders/' + this.serviceOrder.id)
        .then((response) => {
          this.nextOrders = response.content
        })
    },

    async submit() {
      this.loading = true
      if (!this.serviceOrder.responsibleName) {
        this.$toast.error(
          'Insira o responsável para fechar a ordem de serviço!'
        )

        this.signatureErrorDialog = false
        this.loading = false
        return
      }

      if (!this.closeServiceOrderDateTime) {
        this.$toast.error('Adicione a data/hora de fechamento')

        this.signatureErrorDialog = false
        this.loading = false
        return
      }

      const serviceOrder = {
        Id: this.currentServiceOrder.id,
        CloseServiceOrderDateTime: Utils.nowDatetimeFormat(
          this.closeServiceOrderDateTime
        ),
        EmailForEvaluation: this.currentServiceOrder.emailForEvaluation,
        RatingServiceCompleted: this.currentServiceOrder.ratingServiceCompleted,
        RatingServiceTime: this.currentServiceOrder.ratingServiceTime,
        IsExecutingSigned: this.currentServiceOrder.isExecutingSigned,
        ExecutingUserId: this.currentServiceOrder.executingUserId,
        ExecutingUserName: this.currentServiceOrder.executingUserName,
        SignatureData: this.signature,
        CauseDefect: this.currentServiceOrder.causeDefectIndex ?? null,
        UseResponsibleSignature: this.useResponsibleSignature,
      }

      await this.apiService
        .post('serviceOrder/closeServiceOrder', serviceOrder)
        .then(() => {
          this.serviceOrder.closeServiceOrderDateTime =
            serviceOrder.CloseServiceOrderDateTime

          if (
            this.serviceOrder.equipment &&
            this.serviceOrder.equipment.standardEquipment
          ) {
            if (
              this.serviceOrder.serviceOrderType === 4 ||
              this.serviceOrder.serviceOrderType === 'Rotina de Inspeção'
            ) {
              this.step = 2
              this.getNextOrders()
            } else {
              this.step = 3
              this.getNextOrders()
            }
          } else if (
            this.serviceOrder.serviceOrderType === 4 ||
            this.serviceOrder.serviceOrderType === 'Rotina de Inspeção'
          ) {
            this.step = 2
            this.getNextOrders()
          } else {
            this.step = 3
          }
        })
        .catch((err) => {
          const msg =
            err?.response?.data?.message ||
            err?.response?.data ||
            'Erro ao fechar a Ordem de Serviço'
          this.$toast.error(msg)
          console.error('closeServiceOrder failed', err)
        })

      this.signatureErrorDialog = false
      this.useResponsibleSignature = false
      this.loading = false
    },
  },

  watch: {
    closeServiceOrderDateTime(value) {
      if (value) this.closeServiceOrderDateTimeError = false
    },
    menuCloseDate(value) {
      if (value) {
        this.selectedTab = 0
        if (this.$refs.timer) {
          this.$refs.timer.selectingHour = true
        }
      }
    },
  },
}
